import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getCategories() {
    return axiosInstance.get(`vendor/categories`);
}

export function createCategory(category) {
    console.log(category);
    const state = store.getState();
    category.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", category.name);
    // formData.append("image", category.image);
    // formData.append("status", category.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...category
    };
    return axiosInstance.post("vendor/categories", postData,);
}
export function updateCategory(category,id) {
    console.log(category);
    const state = store.getState();
    category.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", category.name);
    // formData.append("image", category.image);
    // formData.append("status", category.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...category
    };
    return axiosInstance.put("vendor/categories?id="+id, postData,);
}

export function getSelectedCategory(id) {
    return axiosInstance.get(`vendor/categories/show?id=`+id);
}

export function getCategoryType(id) {
    return axiosInstance.get(`vendor/categories/types`);
}

export function changeStatusCategory(category,id) {
    console.log(id);
    const state = store.getState();
    category.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", category.name);
    // formData.append("image", category.image);
    // formData.append("status", category.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...category
    };
    return axiosInstance.put("vendor/categories/status?id="+id, postData,);
}
export function deleteCategory(id) {
    return axiosInstance.delete(`vendor/categories?id=`+id);
}